<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Zuordnung an'"
      [name]="'parent'"
      [colSize]="4"
      [formField]="form.get('parent')"
      *ngIf="dataLayerTypeStore.asArray() as dataLayerTypes">
      <app-type-dropdown
        [class.ng-touched]="parent"
        mode="all"
        formControlName="parent"
        (selectionChange)="onParentChange($event)"></app-type-dropdown>
    </app-form-field-wrapper>

    <app-form-field-wrapper
      [label]="'Jahr'"
      [name]="'year'"
      [colSize]="2"
      [formField]="form.get('year')">
      <input
        pInputText
        id="year"
        type="number"
        formControlName="year"
        class="p-input" />
    </app-form-field-wrapper>

    @if (activeUserStore.canUseForecast()) {
      <app-form-field-wrapper
        [label]="'Prognose Jahr'"
        [name]="'isForecast'"
        [colSize]="3">
        <p-inputSwitch formControlName="isForecast"></p-inputSwitch>
      </app-form-field-wrapper>
    }

    <app-form-field-wrapper
      [label]="'öffentlich sichtbar'"
      [name]="'published'"
      [colSize]="3">
      <p-inputSwitch formControlName="published"></p-inputSwitch>
    </app-form-field-wrapper>
  </div>
  <div class="grid">
    <app-form-field-wrapper
      [label]="'Geschützte Informationen'"
      [name]="'description'">
      <textarea
        rows="1"
        cols="30"
        pInputTextarea
        formControlName="description"></textarea>
    </app-form-field-wrapper>
  </div>

  <div class="grid" *ngIf="canImportGeoDataForYear()">
    <div class="col-12 flex align-items-center gap-3 flex-wrap">
      <p-button
        [rounded]="true"
        [outlined]="true"
        styleClass="w-auto"
        severity="warning"
        icon="fas fa-map-location-dot"
        label="Gebietsstand aktualisieren"
        (click)="startGeoDataImport()"></p-button>
      <small class="text-color-secondary">
        Erzeugt neue Geodaten nur für dieses Jahr - frühere Jahre bleiben
        unverändert.
      </small>
    </div>
  </div>

  <p-divider />

  <app-form-footer
    [cancelLevel]="cancelLevel"
    [hideCancelLink]="disableCancelLink"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkDataLayerRights(itemToEdit.parent, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (cancel)="cancel.emit()"
    (removeClick)="itemToEdit ? removeDataLayer(itemToEdit) : undefined" />
</form>

@if (showGeoImport) {
  <p-sidebar
    (onHide)="closeGeoDataImport()"
    position="right"
    [modal]="false"
    [styleClass]="'w-8'"
    [visible]="showGeoImport">
    <ng-template pTemplate="header">
      <app-header
        icon="fas fa-map-location-dot"
        text="Gebietsstand aktualisieren"></app-header>
    </ng-template>
    <ng-container *ngIf="showGeoImport">
      <app-import-export-geodata [lockSelection]="true"></app-import-export-geodata>
    </ng-container>
  </p-sidebar>
  <app-mask [visible]="showGeoImport" (click)="closeGeoDataImport()"></app-mask>
}

<p-confirmDialog
  key="geoDataDecoupleDialog"
  [style]="{ width: '28rem' }"
  [closable]="false"></p-confirmDialog>
